// extracted by mini-css-extract-plugin
module.exports = {"spinnerDiv":"Spinner_spinnerDiv__HBjTf","spinner":"Spinner_spinner__35ZoF"};